import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/DashboardSidebar.css';

const DashboardSidebar = ({ activeItem, setActiveItem, isOpen, setIsOpen }) => {
  const navigate = useNavigate();
  
  const menuItems = [
    {
      id: 'nominations',
      label: 'Nomination',
      icon: 'nominations-icon.png',
      path: '/dashboard/nominations'
    },
    {
      id: 'athletes',
      label: 'Featured Athletes',
      icon: 'featured-icon1.png',
      path: '/dashboard/featured'
    },
    {
      id: 'analytics',
      label: 'Analytics',
      icon: 'analytics-icon.png',
      path: '/dashboard/analytics'
    },
    {
      id: 'email-list',
      label: 'Email List',
      icon: 'email-icon.png',
      path: '/dashboard/email-list'
    },
    {
      id: 'landing-page',
      label: 'Landing Page',
      icon: 'edit-icon.png',
      path: '/dashboard/landing-page'
    },
    {
      id: 'standouts',
      label: 'Standouts',
      icon: 'featured-icon1.png',
      path: '/dashboard/standouts'
    },
    {
      id: 'organizations',
      label: 'Organizations',
      icon: 'featured-icon1.png',
      path: '/dashboard/organizations'
    },
    {
      id: 'users',
      label: 'Users',
      icon: 'nominations-icon.png',
      path: '/dashboard/users'
    },
    {
      id: 'banned-words',
      label: 'Banned Words',
      icon: 'edit-icon.png',
      path: '/dashboard/banned-words'
    },
  ];

  const handleMenuItemClick = (itemId, path) => {
    setActiveItem(itemId);
    navigate(path);
    if (setIsOpen) {
      setIsOpen(false);
    }
  };

  return (
    <>
      {/* Mobile Overlay */}
      {isOpen && (
        <div
          className="dashboard-sidebar-overlay"
          onClick={() => setIsOpen(false)}
        />
      )}

      {/* Sidebar */}
      <div className={`dashboard-sidebar ${isOpen ? 'open' : ''}`}>
        {/* Logo Section */}
        <div className="dashboard-sidebar-logo">
          <img src="/assets/images/logo.png" alt="LegacyStat" />
          <span className="dashboard-sidebar-logo-text"></span>
        </div>

        {/* Menu Items */}
        <nav className="dashboard-sidebar-nav">
          {menuItems.map((item) => (
            <button
              key={item.id}
              className={`dashboard-sidebar-item ${activeItem === item.id ? 'active' : ''}`}
              onClick={() => handleMenuItemClick(item.id, item.path)}
            >
              <img
                src={`/assets/images/${item.icon}`}
                alt={item.label}
                className="dashboard-sidebar-icon"
              />
              <span className="dashboard-sidebar-label">{item.label}</span>
            </button>
          ))}
        </nav>

        {/* Logout Button (Optional) */}
        {/* <div className="dashboard-sidebar-footer">
          <button className="dashboard-sidebar-item" onClick={handleLogout}>
            <img
              src="/assets/images/logout-icon.png"
              alt="Logout"
              className="dashboard-sidebar-icon"
            />
            <span className="dashboard-sidebar-label">Logout</span>
          </button>
        </div> */}
      </div>
    </>
  );
};

export default DashboardSidebar;